var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRightBoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4998 16.9998C10.2438 16.9998 9.98776 16.9018 9.79276 16.7068C9.40176 16.3158 9.40176 15.6838 9.79276 15.2928L13.0978 11.9878L9.91776 8.69476C9.53476 8.29676 9.54576 7.66376 9.94276 7.28076C10.3408 6.89776 10.9738 6.90876 11.3568 7.30476L15.2188 11.3048C15.5978 11.6978 15.5928 12.3208 15.2068 12.7068L11.2068 16.7068C11.0118 16.9018 10.7558 16.9998 10.4998 16.9998Z",
    fill: "#19262F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightBoldIcon);
export default __webpack_public_path__ + "static/media/ChevronRightBoldIcon.695e91f0b080762b1d1906da3e82a817.svg";
export { ForwardRef as ReactComponent };